import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {MessageViewModel} from '../view-models/message-view.model';
import {AttachmentViewModel} from '../view-models/attachment-view.model';
import {DropdownComponent} from '@components/ui/dropdown/dropdown.component';
import {DropdownTriggerForDirective} from '@components/ui/dropdown/directives/dropdown-trigger-for.directive';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DropdownComponent, DropdownTriggerForDirective]
})
export class MessageComponent {

  public readonly message = input.required<MessageViewModel>();
  public readonly downloadAttachment = output<AttachmentViewModel>();
  public readonly deleteAttachment = output<AttachmentViewModel>();

  public download(attachment: AttachmentViewModel): void {
    this.downloadAttachment.emit(attachment);
  }

  public deleteClicked(attachment: AttachmentViewModel, event: Event): void {
    event.stopPropagation();
    this.deleteAttachment.emit(attachment);
  }
}
